"use strict";
import { HoverableValueMixin } from "../hoverable_value_mixin";
export default React.createClass({
  mixins: [HoverableValueMixin],
  getInitialState: function() {
    return {};
  },
  render: function() {
    if (this.props.source) {
      var source = this.props.source;
      var prefix = this.props.prefix || "";
      let country = source[prefix + "country"];
      if (country === "US" || country === "USA") {
        country = void 0;
      }
      const address = {
        name: source[prefix + "name"],
        line1: source[prefix + "address_line_1"],
        line2: source[prefix + "address_line_2"],
        city: source[prefix + "city"],
        state: source[prefix + "state"],
        postal_code: source[prefix + "postal_code"],
        country
      };
      return /* @__PURE__ */ React.createElement("div", { className: "address" }, address.name ? /* @__PURE__ */ React.createElement("div", { className: "address__line" }, this.showValue(address.name)) : "", address.line1 ? /* @__PURE__ */ React.createElement("div", { className: "address__line" }, this.showValue(address.line1)) : "", address.line2 ? /* @__PURE__ */ React.createElement("div", { className: "address__line" }, this.showValue(address.line2)) : "", address.city || address.state || address.postal_code || address.country ? /* @__PURE__ */ React.createElement("div", { className: "address__line" }, address.city ? /* @__PURE__ */ React.createElement("span", { className: "address__piece" }, this.showValue(address.city)) : "", address.city && address.state ? /* @__PURE__ */ React.createElement("span", null, ",") : "", address.state ? /* @__PURE__ */ React.createElement("span", { className: "address__piece" }, this.showValue(address.state)) : "", address.postal_code ? /* @__PURE__ */ React.createElement("span", { className: "address__piece" }, this.showValue(address.postal_code)) : "", address.country ? /* @__PURE__ */ React.createElement("span", { className: "address__piece" }, this.showValue(address.country)) : "") : "");
    } else {
      return /* @__PURE__ */ React.createElement("div", null, this.props.children);
    }
  },
  showValue: function(value) {
    if (this.props.onValueHighlighted) {
      return this.showHoverableValue(value);
    } else {
      return value;
    }
  }
});
